import { request } from '@/shared/api/request'

export const deleteReviewXml = (data) => request({ url: `contract/review/delete/xml`, method: 'DELETE', params: data })